import * as Yup from 'yup';

const addEditServiceValidationSchema = Yup.object().shape({
  type: Yup.string().required('Please enter your service type')
});

export default addEditServiceValidationSchema;
